import { render } from "./contract.vue?vue&type=template&id=fd9fbbe4&scoped=true"
import script from "./contract.vue?vue&type=script&lang=js"
export * from "./contract.vue?vue&type=script&lang=js"

import "./contract.vue?vue&type=style&index=0&id=fd9fbbe4&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd9fbbe4"]])

export default __exports__